import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// minRole: "guest" (default) — any authenticated user may access
//          "editor"          — only users with role "editor" may access
const ProtectedRoute = ({ children, minRole = "guest" }) => {
  const { user, userRole, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (minRole === "editor" && userRole !== "editor") {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
